import Layout from "@components/Collection/artist/Layout";

export default Layout;
